import { Check } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";

const PreiseSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="preise" data-testid="preise-section" className="section-padding bg-white" ref={sectionRef}>
      <div className="container-custom">
        <div className="text-center mb-16 reveal">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-4 italic">Transparenz</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4 font-[Outfit]">Thermomix® TM7 Preise & Pakete in Krefeld</h2>
          <p className="text-slate-500">Sichere dir deinen Vorteil in Krefeld!</p>
        </div>

        <div className="grid grid-cols-1 max-w-2xl mx-auto reveal reveal-delay-1">
          {/* Basis */}
          <div className="glass-card rounded-[2rem] p-10 hover-lift flex flex-col">
            <h4 className="text-2xl font-bold mb-2 font-[Outfit]">TM7 Basis-Paket</h4>
            <p className="text-slate-400 text-sm mb-8 italic">Der perfekte Einstieg – immer verfügbar</p>
            <div className="flex items-baseline gap-2 mb-8">
              <span className="text-4xl font-extrabold text-slate-900">1.549 €</span>
              <span className="text-sm text-slate-500">inkl. Lieferung</span>
            </div>
            <ul className="space-y-4 mb-10 flex-grow">
              {["Thermomix® TM7 Multitalent", "Vollständiges Varoma® Zubehör", "Gareinsatz & Rühraufsatz", "3 Monate Cookidoo® Gratis", "Persönlicher Premium-Service in Krefeld"].map((li, i) => (
                <li key={i} className="flex items-center gap-3 text-sm font-medium text-slate-600">
                  <Check className="text-emerald-500 w-4 h-4 flex-shrink-0" /> {li}
                </li>
              ))}
            </ul>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }); }} data-testid="preise-basis-cta" className="w-full py-4 text-center bg-slate-900 text-white rounded-full font-bold hover:bg-slate-800 transition">Anfrage senden</a>
          </div>
        </div>

        <p className="text-center text-sm text-slate-500 mt-8 max-w-xl mx-auto reveal reveal-delay-2">
          💡 Aktuelle Sonderaktionen & zeitlich begrenzte Pakete findest du <a href="#angebote" onClick={(e) => { e.preventDefault(); document.getElementById("angebote")?.scrollIntoView({ behavior: "smooth" }); }} className="text-emerald-600 font-semibold hover:underline">weiter unten in den Angeboten</a>.
        </p>
      </div>
    </section>
  );
};

export default PreiseSection;
